import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{"icon18/NLP"}</title>
    <defs>
      <radialGradient
        cx="11.3172631%"
        cy="2.52121261%"
        fx="11.3172631%"
        fy="2.52121261%"
        r="124.298356%"
        id="GBwopjmvQuTydDrpXPl1k__radialGradient-1"
      >
        <stop stopColor="#FFC074" offset="0%" />
        <stop stopColor="#FF6B2C" offset="100%" />
      </radialGradient>
      <rect
        id="GBwopjmvQuTydDrpXPl1k__path-2"
        x={0}
        y={0}
        width={18}
        height={18}
        rx={2}
      />
      <filter
        x="-5.6%"
        y="-5.6%"
        width="111.1%"
        height="111.1%"
        filterUnits="objectBoundingBox"
        id="GBwopjmvQuTydDrpXPl1k__filter-3"
      >
        <feGaussianBlur
          stdDeviation={0.5}
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx={0}
          dy={1}
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2={-1}
          k3={1}
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.0530553431 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
      <linearGradient
        x1="109.459011%"
        y1="49.422997%"
        x2="-21.7299389%"
        y2="48.9668338%"
        id="GBwopjmvQuTydDrpXPl1k__linearGradient-4"
      >
        <stop stopColor="#FFE1C4" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <path
        d="M2.85,11.68 C2.85,11.8133333 2.8,11.9333333 2.7,12.04 C2.6,12.1466667 2.43333333,12.2 2.2,12.2 C1.96666667,12.2 1.8,12.1433333 1.7,12.03 C1.6,11.9166667 1.55,11.8 1.55,11.68 L1.55,5.5 C1.55,5.38 1.58333333,5.27166667 1.65,5.175 C1.71666667,5.07833333 1.87,5.03 2.11,5.03 C2.24333333,5.03 2.35166667,5.07 2.435,5.15 C2.51833333,5.23 2.59,5.31 2.65,5.39 L5.81,9.64 L5.81,5.55 C5.81,5.43 5.86,5.31333333 5.96,5.2 C6.06,5.08666667 6.22666667,5.03 6.46,5.03 C6.69333333,5.03 6.86,5.08333333 6.96,5.19 C7.06,5.29666667 7.11,5.41666667 7.11,5.55 L7.11,11.75 C7.11,11.8633333 7.07666667,11.9666667 7.01,12.06 C6.94333333,12.1533333 6.79333333,12.2 6.56,12.2 C6.42666667,12.2 6.315,12.16 6.225,12.08 C6.135,12 6.06,11.92 6,11.84 L2.85,7.73 L2.85,11.68 Z M10.97,10.94 C11.1033333,10.94 11.2233333,10.985 11.33,11.075 C11.4366667,11.165 11.49,11.3133333 11.49,11.52 C11.49,11.7333333 11.4333333,11.8833333 11.32,11.97 C11.2066667,12.0566667 11.09,12.1 10.97,12.1 L8.42,12.1 C8.2,12.1 8.02666667,12.03 7.9,11.89 C7.77333333,11.75 7.71,11.58 7.71,11.38 L7.71,5.54 C7.71,5.38 7.77333333,5.255 7.9,5.165 C8.02666667,5.075 8.18,5.03 8.36,5.03 C8.55333333,5.03 8.71,5.075 8.83,5.165 C8.95,5.255 9.01,5.38 9.01,5.54 L9.01,10.94 L10.97,10.94 Z M12.09,5.79 C12.09,5.65 12.1016667,5.53666667 12.125,5.45 C12.1483333,5.36333333 12.1933333,5.29666667 12.26,5.25 C12.3266667,5.20333333 12.4216667,5.17166667 12.545,5.155 C12.6683333,5.13833333 12.83,5.13 13.03,5.13 L14.44,5.13 C14.88,5.13 15.2516667,5.16666667 15.555,5.24 C15.8583333,5.31333333 16.1066667,5.43666667 16.3,5.61 C16.4933333,5.78333333 16.6333333,6.01166667 16.72,6.295 C16.8066667,6.57833333 16.85,6.92666667 16.85,7.34 C16.85,7.75333333 16.8033333,8.10666667 16.71,8.4 C16.6166667,8.69333333 16.4733333,8.93333333 16.28,9.12 C16.0866667,9.30666667 15.8383333,9.44333333 15.535,9.53 C15.2316667,9.61666667 14.8666667,9.66 14.44,9.66 L13.39,9.66 L13.39,11.68 C13.39,11.8133333 13.34,11.9333333 13.24,12.04 C13.14,12.1466667 12.9733333,12.2 12.74,12.2 C12.5066667,12.2 12.34,12.1433333 12.24,12.03 C12.14,11.9166667 12.09,11.8 12.09,11.68 L12.09,5.79 Z M13.39,8.54 L14.44,8.54 C14.8666667,8.54 15.1583333,8.44666667 15.315,8.26 C15.4716667,8.07333333 15.55,7.77 15.55,7.35 C15.55,7.13 15.5216667,6.95 15.465,6.81 C15.4083333,6.67 15.33,6.55833333 15.23,6.475 C15.13,6.39166667 15.0133333,6.335 14.88,6.305 C14.7466667,6.275 14.6,6.26 14.44,6.26 L13.39,6.26 L13.39,8.54 Z"
        id="GBwopjmvQuTydDrpXPl1k__path-5"
      />
      <filter
        x="-45.8%"
        y="-69.7%"
        width="191.5%"
        height="295.3%"
        filterUnits="objectBoundingBox"
        id="GBwopjmvQuTydDrpXPl1k__filter-6"
      >
        <feOffset dx={0} dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={2}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.607704937   0 0 0 0 0.364719605   0 0 0 0 0.116202726  0 0 0 0.280951227 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g
      id="GBwopjmvQuTydDrpXPl1k__icon18/NLP"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g id="GBwopjmvQuTydDrpXPl1k__\u77E9\u5F62">
        <use
          fill="url(#GBwopjmvQuTydDrpXPl1k__radialGradient-1)"
          fillRule="evenodd"
          xlinkHref="#GBwopjmvQuTydDrpXPl1k__path-2"
        />
        <use
          fill="black"
          fillOpacity={1}
          filter="url(#GBwopjmvQuTydDrpXPl1k__filter-3)"
          xlinkHref="#GBwopjmvQuTydDrpXPl1k__path-2"
        />
      </g>
      <g id="GBwopjmvQuTydDrpXPl1k__\u5F62\u72B6\u7ED3\u5408">
        <use
          fill="black"
          fillOpacity={1}
          filter="url(#GBwopjmvQuTydDrpXPl1k__filter-6)"
          xlinkHref="#GBwopjmvQuTydDrpXPl1k__path-5"
        />
        <use
          fill="url(#GBwopjmvQuTydDrpXPl1k__linearGradient-4)"
          fillRule="evenodd"
          xlinkHref="#GBwopjmvQuTydDrpXPl1k__path-5"
        />
      </g>
    </g>
  </svg>
);
const Memo = memo(Icon);
export default Memo;
